export default {
  title: 'Payees',
  hubBadge: 'Treasury & Payees Hub',
  hubDescription: 'Manage beneficiaries, employees, suppliers, and other cash-out payees for payment vouchers.',
  tabs: {
    all: 'All Payees',
    vendor: 'Suppliers (Vendors)',
    employee: 'Employees',
    other: 'Other Payees',
  },
  filters: {
    searchPlaceholder: 'Search payee, company, phone...',
    crmStatus: 'CRM Status',
    activeOnly: 'Active Only',
    disabledOnly: 'Disabled Only',
  },
  columns: {
    seq: '#',
    name: 'Payee Name',
    nameFa: 'Persian / Dari Name',
    type: 'Classification (Type)',
    contact: 'Contact Info',
    qboId: 'QBO Reference',
    branch: 'Branch',
    allBranches: 'All Branches',
    active: 'Active in CRM',
    actions: 'Actions',
  },
  types: {
    employee: 'Employee',
    vendor: 'Supplier / Vendor',
    other: 'Other Payee',
  },
  actions: {
    sync: 'Sync from QBO',
    syncing: 'Syncing…',
    add: 'Add Payee / Other',
    edit: 'Edit',
  },
  dialog: {
    createTitle: 'Add Payee',
    createDescription: 'Create a new payee for payment vouchers.',
    editTitle: 'Edit Payee',
    editDescription: 'Update profile and contact details.',
    nameLabel: 'Primary / Latin Name',
    namePlaceholder: 'Payee name...',
    nameFaLabel: 'Persian / Dari Name',
    nameFaPlaceholder: 'Persian name...',
    typeLabel: 'Category (Type)',
    companyLabel: 'Company Name',
    companyPlaceholder: 'Optional...',
    phoneLabel: 'Phone Number',
    emailLabel: 'Email',
    branchLabel: 'CRM Branch',
    branchPlaceholder: 'Select Branch (Optional)',
    noSpecificBranch: 'All Branches (Unrestricted)',
    notesLabel: 'Notes',
    notesPlaceholder: 'Optional notes...',
    qboAccountLabel: 'Linked QuickBooks Account',
    qboAccountPlaceholder: 'Select Account (Optional)',
    noSpecificAccount: 'No link',
    activeLabel: 'Active in CRM',
    activeDesc: 'Master active status for this payee in CRM',
    formVisibility: 'Form Availability',
    allowedInVoucher: 'Payment Voucher',
    allowedInVoucherDesc: 'Show this payee in payment vouchers',
    allowedInExpenseReport: 'Expense Report Form',
    allowedInExpenseReportDesc: 'Show this payee in expense report forms',
    optional: 'Optional',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving…',
  },
  messages: {
    syncSuccess: 'Sync Completed ✓',
    syncSuccessDesc: 'Payees synchronized from QuickBooks Online.',
    syncError: 'Failed to sync payees from QuickBooks',
    createSuccess: 'Payee Created ✓',
    createSuccessDesc: 'Successfully added to CRM payees.',
    updateSuccess: 'Payee Updated ✓',
    updateSuccessDesc: 'Payee details saved successfully.',
    saveFailed: 'Failed to save payee',
    validationError: 'Validation Error',
    nameRequired: 'Payee name is required.',
    loadError: 'Error loading payees',
    statusUpdated: 'CRM status updated.',
  },
};
